import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Manutencoes() {
  const [manutencoesList, setManutencoesList] = useState([]);
  const [frotaList, setFrotaList] = useState([]);

  const [editandoId, setEditandoId] = useState(null);
  const [veiculo, setVeiculo] = useState('');
  const [tipo, setTipo] = useState('Preventiva');
  const [descricao, setDescricao] = useState('');
  const [data, setData] = useState('');
  const [odometro, setOdometro] = useState('');
  const [custo, setCusto] = useState('');
  const [situacao, setSituacao] = useState('Agendada');

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      const [resMan, resFrota] = await Promise.all([
        api.get('/manutencoes'),
        api.get('/frota')
      ]);
      setManutencoesList(Array.isArray(resMan.data) ? resMan.data : []);
      setFrotaList(Array.isArray(resFrota.data) ? resFrota.data : []);
    } catch (err) {
      console.error("Erro ao carregar dados:", err);
    }
  };

  const salvarManutencao = async (e) => {
    e.preventDefault();
    const manId = editandoId || Date.now().toString();
    const dados = {
      id: manId,
      veiculo: veiculo || (frotaList[0]?.placa || 'PAC1000'),
      tipo,
      descricao,
      data: data || new Date().toISOString().split('T')[0],
      odometro,
      custo: parseFloat(custo) || 0,
      situacao
    };

    try {
      const url = editandoId ? `/api/manutencoes/${editandoId}` : '/api/manutencoes';
      const method = editandoId ? 'PUT' : 'POST';

      if (editandoId) {
        await api.put(`/manutencoes/${editandoId}`, dados);
      } else {
        await api.post('/manutencoes', dados);
      }

      {
        limparFormulario();
        carregarDados();
        alert(editandoId ? 'Manutenção e Financeiro atualizados!' : 'Manutenção registrada e lançada no Financeiro!');
      }
    } catch (err) {
      console.error("Erro:", err);
      alert('Erro de conexão ao salvar manutenção.');
    }
  };

  const editarManutencao = (m) => {
    setEditandoId(m.id);
    setVeiculo(m.veiculo);
    setTipo(m.tipo);
    setDescricao(m.descricao);
    setData(m.data);
    setOdometro(m.odometro);
    setCusto(m.custo);
    setSituacao(m.situacao);
  };

  const excluirManutencao = async (id) => {
    if (!window.confirm("Deseja realmente excluir esta manutenção?")) return;
    try {
      await api.delete(`/manutencoes/${id}`);
      await carregarDados();
    } catch (err) {
      console.error("Erro:", err);
    }
  };

  const limparFormulario = () => {
    setEditandoId(null);
    setVeiculo('');
    setTipo('Preventiva');
    setDescricao('');
    setData('');
    setOdometro('');
    setCusto('');
    setSituacao('Agendada');
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '20px', padding: '20px', color: '#fff' }}>
      <div style={{ background: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px' }}>
          {editandoId ? '✏️ Editar Manutenção' : '+ Nova Manutenção'}
        </h3>
        <form onSubmit={salvarManutencao} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label style={{ fontSize: '12px', color: '#a0a0a0' }}>VEÍCULO</label>
            <select value={veiculo} onChange={e => setVeiculo(e.target.value)} style={inputStyle} required>
              <option value="">Selecione o Veículo</option>
              {frotaList.map(f => <option key={f.id || f.placa} value={f.placa}>{f.placa} - {f.modelo}</option>)}
            </select>
          </div>

          <div>
            <label style={{ fontSize: '12px', color: '#a0a0a0' }}>TIPO</label>
            <select value={tipo} onChange={e => setTipo(e.target.value)} style={inputStyle}>
              <option value="Preventiva">Preventiva</option>
              <option value="Corretiva">Corretiva</option>
            </select>
          </div>

          <div>
            <label style={{ fontSize: '12px', color: '#a0a0a0' }}>DESCRIÇÃO</label>
            <textarea value={descricao} onChange={e => setDescricao(e.target.value)} placeholder="Ex: Troca de óleo e filtros" style={{ ...inputStyle, height: '80px' }} required />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={{ fontSize: '12px', color: '#a0a0a0' }}>DATA</label>
              <input type="date" value={data} onChange={e => setData(e.target.value)} style={inputStyle} required />
            </div>
            <div>
              <label style={{ fontSize: '12px', color: '#a0a0a0' }}>ODÔMETRO (KM)</label>
              <input type="text" value={odometro} onChange={e => setOdometro(e.target.value)} placeholder="Ex: 60000" style={inputStyle} required />
            </div>
          </div>

          <div>
            <label style={{ fontSize: '12px', color: '#a0a0a0' }}>CUSTO (R$)</label>
            <input type="number" step="0.01" value={custo} onChange={e => setCusto(e.target.value)} placeholder="250.00" style={inputStyle} required />
          </div>

          <div>
            <label style={{ fontSize: '12px', color: '#a0a0a0' }}>SITUAÇÃO</label>
            <select value={situacao} onChange={e => setSituacao(e.target.value)} style={inputStyle}>
              <option value="Agendada">Agendada</option>
              <option value="Em Andamento">Em Andamento</option>
              <option value="Concluída">Concluída</option>
            </select>
          </div>

          <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            <button type="submit" style={{ flex: 1, padding: '12px', background: editandoId ? '#f0ad4e' : '#007AFF', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
              {editandoId ? 'Atualizar Manutenção' : 'Registrar Manutenção'}
            </button>
            {editandoId && (
              <button type="button" onClick={limparFormulario} style={{ padding: '12px 16px', background: '#444', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
                Cancelar
              </button>
            )}
          </div>
        </form>
      </div>

      <div style={{ background: '#141414', border: '1px solid #2a2a2a', padding: '20px', borderRadius: '8px' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px' }}>Histórico de Manutenções</h3>
        {manutencoesList.length === 0 ? (
          <p style={{ color: '#888', textAlign: 'center', marginTop: '40px' }}>Nenhuma manutenção registrada.</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #2a2a2a', color: '#a0a0a0' }}>
                <th style={{ padding: '10px' }}>Veículo</th>
                <th style={{ padding: '10px' }}>Tipo / Descrição</th>
                <th style={{ padding: '10px' }}>Custo</th>
                <th style={{ padding: '10px' }}>Situação</th>
                <th style={{ padding: '10px', textAlign: 'right' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {manutencoesList.map(m => (
                <tr key={m.id} style={{ borderBottom: '1px solid #222' }}>
                  <td style={{ padding: '10px', fontWeight: 'bold' }}>{m.veiculo}</td>
                  <td style={{ padding: '10px' }}><b>{m.tipo}</b><br/><span style={{ color: '#aaa', fontSize: '11px' }}>{m.descricao}</span></td>
                  <td style={{ padding: '10px', color: '#FF3B30', fontWeight: 'bold' }}>R$ {Number(m.custo || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                  <td style={{ padding: '10px', color: '#32D74B' }}>{m.situacao}</td>
                  <td style={{ padding: '10px', textAlign: 'right' }}>
                    <button onClick={() => editarManutencao(m)} style={{ padding: '4px 8px', background: '#333', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', marginRight: '6px' }}>Editar</button>
                    <button onClick={() => excluirManutencao(m.id)} style={{ padding: '4px 8px', background: '#FF3B30', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>Excluir</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const inputStyle = { width: '100%', padding: '10px', background: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', boxSizing: 'border-box', marginTop: '4px' };